import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-slice",
  "use": "icon-slice-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-slice\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M10.9,14.79l-5,5-.55-.56a1.57,1.57,0,0,1,0-2.2l3.87-3.87,1.66,1.65ZM5.76,7.35A1.56,1.56,0,1,0,7.32,5.79,1.56,1.56,0,0,0,5.76,7.35Zm9.36,0a1.56,1.56,0,1,0,1.56-1.56A1.56,1.56,0,0,0,15.12,7.35Zm.34,2.88L13.65,12l5,5a1.57,1.57,0,0,1,0,2.2l-.56.56L8.54,10.23a3.12,3.12,0,1,1,1.65-1.66L12,10.38l1.81-1.81a3.12,3.12,0,1,1,1.65,1.66Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol